<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="body Part" id="section_part--num_1--seq_4"> <div class="title-block"><p class="title-num"><a href="#/9781847675651_toc"><i>Book One</i></a></p> <h1><a href="#/9781847675651_toc">Wahn, wahn, überall wahn …</a></h1></div> </div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847675651_part_01.vue?3211d616